import { Injectable, Injector } from '@angular/core';
import { IAttachmentSource, SalesforceAttachmentSource } from 'attachment-source-lib';
import { SalesforceAuthService } from 'auth-service-lib';
import { SalesforceDataSourceApiService } from 'datasource-service-lib';
import { SalesforceDocumentDestinationService } from 'document-destination-service-lib';
import { SalesforceEntityMetadataService } from 'entity-metadata-service-lib';
import { SalesforceEntityPathService } from 'entity-path-service-lib';
import { SalesforceEntityPickerService } from 'entity-picker-lib';
import { SalesforceFileDataSourceApiService } from 'file-datasource-service-lib';
import { SalesforceIconService } from 'icon-service-lib';
import {
  IAuthService,
  IDataSourceApiService,
  IEntityMetadataService,
  IEntityPickerService,
  IEntityTypeOption,
  IFileDataSourceApiService,
  IIconService,
  ISharedServiceProviderService
} from 'interfaces-lib';
import { jwtDecode } from 'jwt-decode';
import { INamedEntityService, SalesforceNamedEntityService } from 'named-entity-service-lib';
import { Observable } from 'rxjs';
import { IRecipientInfoService, SalesforceRecipientInfoService } from 'recipient-info-service-lib';
import { ITerminologyService, SalesforceTerminologyService } from 'terminology-lib';
import { SalesforceEntityTypeMappingsService } from './salesforce-entity-type-mappings.service';

@Injectable({ providedIn: 'root' })
export class SalesforceSharedServiceProviderService implements ISharedServiceProviderService {
  constructor(private injector: Injector) {}

  getAuthService(): IAuthService {
    return this.injector.get(SalesforceAuthService);
  }

  getDataSourceApiService(): IDataSourceApiService {
    return this.injector.get(SalesforceDataSourceApiService);
  }

  getEntityMetadataService(): IEntityMetadataService {
    return this.injector.get(SalesforceEntityMetadataService);
  }

  getIconService(): IIconService {
    return this.injector.get(SalesforceIconService);
  }

  getAttachmentSourceService(): IAttachmentSource {
    return this.injector.get(SalesforceAttachmentSource);
  }

  getEntityPickerService(): IEntityPickerService {
    return this.injector.get(SalesforceEntityPickerService);
  }

  getRecipientInfoService(): IRecipientInfoService {
    return this.injector.get(SalesforceRecipientInfoService);
  }

  getTerminologyService(): ITerminologyService {
    return this.injector.get(SalesforceTerminologyService);
  }

  getNamedEntityService(): INamedEntityService {
    return this.injector.get(SalesforceNamedEntityService);
  }

  getEntityPathService() {
    return this.injector.get(SalesforceEntityPathService);
  }

  getDocumentDestinationService() {
    return this.injector.get(SalesforceDocumentDestinationService);
  }

  getFileDataSourceApiService(): IFileDataSourceApiService {
    return this.injector.get(SalesforceFileDataSourceApiService);
  }

  getCorpId(token: string): string {
    const decoded = jwtDecode<{ organizationId?: string }>(token);
    if (!decoded.organizationId) {
      throw new Error('organizationId not found in Salesforce token');
    }
    return decoded.organizationId;
  }

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    return this.injector.get(SalesforceEntityTypeMappingsService).getEntityTypeOptions(parentEntityType);
  }
}
